import Nullstack from 'nullstack';
export default function IconIroningSteamOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ironing-steam-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 4h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.821 1.15"
  }), "   ", Nullstack.element("path", {
    d: "M16 16h-13a7.001 7.001 0 0 1 6.056 -6.937"
  }), "   ", Nullstack.element("path", {
    d: "M13 9h6.8"
  }), "   ", Nullstack.element("path", {
    d: "M12 19v2"
  }), "   ", Nullstack.element("path", {
    d: "M8 19l-1 2"
  }), "   ", Nullstack.element("path", {
    d: "M16 19l1 2"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}